module.exports = __webpack_public_path__ + "img/149-czech-republic.ca7ecb6a.svg";